/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { pluginsGetDistributionPlugin } from "../funcs/pluginsGetDistributionPlugin.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { DistributionPlugin } from "../models/components/distributionplugin.js";
import {
  GetDistributionPluginRequest,
  GetDistributionPluginSecurity,
} from "../models/operations/getdistributionplugin.js";
import { unwrapAsync } from "../types/fp.js";
export type DistributionPluginQueryData = DistributionPlugin;

export function prefetchDistributionPlugin(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetDistributionPluginRequest,
  security?: GetDistributionPluginSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildDistributionPluginQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildDistributionPluginQuery(
  client$: GramCore,
  request: GetDistributionPluginRequest,
  security?: GetDistributionPluginSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<DistributionPluginQueryData>;
} {
  return {
    queryKey: queryKeyDistributionPlugin({
      skillId: request.skillId,
      id: request.id,
      gramSession: request.gramSession,
      gramProject: request.gramProject,
    }),
    queryFn: async function distributionPluginQueryFn(
      ctx,
    ): Promise<DistributionPluginQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(pluginsGetDistributionPlugin(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyDistributionPlugin(
  parameters: {
    skillId: string;
    id: string;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "plugins", "getDistributionPlugin", parameters];
}
